

export const injectLocaleToUrl = (url: string | URL, locale: string) => {
    const u = new URL(url);

    u.searchParams.append('lang', locale);

    return u.toString();
}
